import { Utils } from 'src/app/core/utils/utils';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../auth/authentication.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IsLoggedGuard {

  constructor(private authService: AuthenticationService, private router: Router) { }

  /**
   * @description
   * En caso de que no haya usuario logueado en el servidor redirigimos a la página de error
   * @param next Ruta siguiente
   * @param state Ruta actual
   */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isLogged()
      .pipe(map(result => {
        if (Utils.noUndfAndNull(result) && result) {
          return true;
        } else {
          this.router.navigate(['/internal/acces']);
          return false; 
        }
      }, (error: any) => {
        console.log(error);
        this.router.navigate(['/internal/acces']);
      }));
  }
}
